$(function () {
	$('.js-agree').change(function() {
		let $this = $(this);
		let btn = $this.closest('.js-form').find('.js-submit');
		if ($this.is(':checked')) {
			btn.removeAttr("disabled");
		} else {
			btn.attr("disabled", true);
		}
	});
});

